import {
    createRouter,
    createWebHistory,
    createWebHashHistory,
    RouteRecordRaw,
} from "vue-router";
import {useUserStore} from "@/store/user";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "Home",
        component: () => import("@/views/index/home.vue"),
        meta: {title: "首页", wechatBrowserGuide: true, wechatSliderGate: true}
    },
    {
        // 新发放的店铺链接使用语义化路径；旧链接通过 alias 保持可访问。
        path: "/shop/:tk",
        alias: "/ProductEn/Index/:tk",
        name: "Index",
        component: () => import("@/views/index/index.vue"),
        meta: {title: "首页", wechatBrowserGuide: true, wechatSliderGate: true}
    },
    {
        path: "/kd_shop/:tk",
        alias: "/ProductEn/KdIndex/:tk",
        name: "KdIndex",
        component: () => import("@/views/index/KdIndex.vue"),
        meta: {title: "宽带广场", wechatBrowserGuide: true, wechatSliderGate: true}
    },
    {
        path: "/ty_shop/:tk",
        alias: "/ProductEn/TyIndex/:tk",
        name: "TyIndex",
        component: () => import("@/views/index/TyIndex.vue"),
        meta: {title: "省内产品集合中心", wechatBrowserGuide: true, wechatSliderGate: true}
    },
    {
        path: "/ProductEn/Shop/:tk",
        name: "ShopPoster",
        component: () => import("@/views/index/ShopPoster.vue"),
        meta: {title: "店铺海报", wechatBrowserGuide: true, wechatSliderGate: false}
    },
    {
        // 新链接使用 tk/productId；旧的 userid/pudID 查询参数仍由页面兼容解析。
        path: "/product",
        alias: "/h5orderEn/index",
        name: "GoodsDetails",
        component: () => import("@/views/goods/GoodsDetails.vue"),
        meta: {title: "商品详情", wechatBrowserGuide: true, wechatSliderGate: true}
    },
    {
        path: "/Pay/WxToBrowser",
        name: "WxPayMiddle",
        component: () => import("@/views/pay/WxPayMiddle.vue"),
        meta: {title: "支付", wechatBrowserGuide: false, wechatSliderGate: false}
    },
    {
        path: "/Pay/AlipayReturn_url/:status",
        name: "AlipayReturnUrl",
        component: () => import("@/views/pay/AlipayReturnUrl.vue"),
        meta: {title: "支付结果", wechatBrowserGuide: false, wechatSliderGate: false}
    },
    {
        path: "/PackInfo/Detail/:pro_id",
        name: "PackageDetails",
        component: () => import("@/views/goods/PackageDetails.vue"),
        meta: {title: "套餐详情", wechatBrowserGuide: false, wechatSliderGate: true}
    },
    {
        path: "/Search/Index",
        name: "OrderQuery",
        component: () => import("@/views/order/OrderQuery.vue"),
        meta: {title: "订单查询", wechatBrowserGuide: false, wechatSliderGate: false}
    },
    {
        path: "/Search/GOrder",
        name: "OrderList",
        component: () => import("@/views/order/OrderList.vue"),
        meta: {title: "订单列表", wechatBrowserGuide: false, wechatSliderGate: true}
    },
    {
        path: "/Search/Ord",
        name: "OrderDetails",
        component: () => import("@/views/order/OrderDetails.vue"),
        meta: {title: "订单详情", wechatBrowserGuide: false, wechatSliderGate: true}
    },
    {
        path: "/Search/Express",
        name: "OrderWuliu",
        component: () => import("@/views/order/OrderWuliu.vue"),
        meta: {title: "物流信息", wechatBrowserGuide: false, wechatSliderGate: false}
    },
    {
        path: "/Search/CourierExpress",
        name: "CourierOrderWuliu",
        component: () => import("@/views/order/CourierOrderWuliu.vue"),
        meta: {title: "物流信息", wechatBrowserGuide: false, wechatSliderGate: true}
    },
    {
        path: "/PicEdit/PicInfo",
        name: "OrderPicEdit",
        component: () => import("@/views/order/OrderPicEdit.vue"),
        meta: {title: "证件信息上传", wechatBrowserGuide: false, wechatSliderGate: false}
    },
    {
        path: "/PicEdit/Index",
        name: "OrderPicEditWarning",
        component: () => import("@/views/order/OrderPicEditWarning.vue"),
        meta: {title: "证件信息上传", wechatBrowserGuide: false, wechatSliderGate: false}
    }
];

// history: createWebHistory(process.env.BASE_URL),
const router = createRouter({
    history: createWebHistory(),
    routes,
});

export const isSetUserTk = ["Index","KdIndex","TyIndex", "ShopPoster","GoodsDetails"];


router.beforeEach((to, from, next) => {
    const {setUserInfo} = useUserStore();
    // 构建新的 hash 值
    if (isSetUserTk.includes(to.name as string)) {
        if (setUserInfo(to)) {
            next();
        }
    } else {
        next();
    }
});

router.afterEach((to) => {
    document.title = (to.meta?.title as string) || "首页";
});


export default router;
